import React from 'react';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  OutlinedInput,
  OutlinedInputProps
} from '@mui/material';

export type AppOutlinedFieldProps = {
  label: React.ReactNode;
  helperText?: React.ReactNode;
} & OutlinedInputProps;

const AppOutlinedField: React.FC<AppOutlinedFieldProps> = ({
  label,
  helperText,
  fullWidth = true,
  ...outlinedProps
}) => (
  <FormControl fullWidth={fullWidth} error={!!outlinedProps.error}>
    <FormLabel>{label}</FormLabel>
    <OutlinedInput {...outlinedProps} fullWidth={fullWidth} />
    {helperText != null && helperText !== '' ? (
      <FormHelperText>{helperText}</FormHelperText>
    ) : null}
  </FormControl>
);

export default AppOutlinedField;
